import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { IBooking } from '../../common/types/apiSchema';

export { GET_BOOKINGS, IBookingQueryData };

const GET_BOOKINGS: DocumentNode = gql`
  {
    bookings {
      id
      title
      status
      saleLocation {
        city {
          id
          name
        }
        country {
          id
          name
        }
        continent {
          id
          name
        }
        division {
          id
          name
        }
        latitude
        longitude
      }
      leadImage {
        url
        urlWithSize
        caption
      }
      bookingDates {
        start
        end
      }
      amendedDates {
        start
        end
      }
      duration
      rooms
      links {
        viewExternalBookingDetails
      }
    }
  }
`;

interface IBookingQueryData {
  bookings: IBooking[];
}
